var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wsm",
    {
      class: [
        _vm.$root.isadmin && _vm.translationMode ? "wsmContainer" : "",
        _vm.active || _vm.openTranslator ? "activeElHoverWsm" : "",
      ],
    },
    [
      _c("VHTML", { attrs: { html: _vm.newText } }),
      _c("transition", { attrs: { name: "bounce" } }, [
        !_vm.loading && _vm.$root.isadmin && _vm.translationMode
          ? _c(
              "span",
              {
                ref: "transIcon",
                staticClass: "langBtn",
                class: [_vm.openTranslator ? "activeIcon" : ""],
                style: { left: _vm.howFarLeft },
                on: {
                  mouseover: function ($event) {
                    _vm.active = true
                  },
                  click: function ($event) {
                    _vm.openTranslator = !_vm.openTranslator
                    _vm.disableLink()
                  },
                  mouseleave: function ($event) {
                    _vm.active = false
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 640 512",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z",
                      },
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c("transition", { attrs: { name: "bounce" } }, [
        _vm.openTranslator && _vm.$root.isadmin && _vm.translationMode
          ? _c(
              "div",
              { class: ["translateWindow"] },
              [
                _c(
                  "span",
                  {
                    staticClass: "close",
                    on: {
                      click: function ($event) {
                        _vm.openTranslator = !_vm.openTranslator
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 320 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c(
                  "transition",
                  { attrs: { name: "fading", mode: "out-in" } },
                  [
                    _vm.loadingData
                      ? _c(
                          "div",
                          {
                            key: "loadingWrapper",
                            staticClass: "loadingWrapper",
                          },
                          [
                            _c("div", { staticClass: "loadingIconWrapper" }, [
                              _c(
                                "div",
                                { staticClass: "loadingIconBackground" },
                                [
                                  _c("div", { staticClass: "loadingCircle" }),
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "loadingIcon",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 640 512",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M448 164C459 164 468 172.1 468 184V188H528C539 188 548 196.1 548 208C548 219 539 228 528 228H526L524.4 232.5C515.5 256.1 501.9 279.1 484.7 297.9C485.6 298.4 486.5 298.1 487.4 299.5L506.3 310.8C515.8 316.5 518.8 328.8 513.1 338.3C507.5 347.8 495.2 350.8 485.7 345.1L466.8 333.8C462.4 331.1 457.1 328.3 453.7 325.3C443.2 332.8 431.8 339.3 419.8 344.7L416.1 346.3C406 350.8 394.2 346.2 389.7 336.1C385.2 326 389.8 314.2 399.9 309.7L403.5 308.1C409.9 305.2 416.1 301.1 422 298.3L409.9 286.1C402 278.3 402 265.7 409.9 257.9C417.7 250 430.3 250 438.1 257.9L452.7 272.4L453.3 272.1C465.7 259.9 475.8 244.7 483.1 227.1H376C364.1 227.1 356 219 356 207.1C356 196.1 364.1 187.1 376 187.1H428V183.1C428 172.1 436.1 163.1 448 163.1L448 164zM160 233.2L179 276H140.1L160 233.2zM0 128C0 92.65 28.65 64 64 64H576C611.3 64 640 92.65 640 128V384C640 419.3 611.3 448 576 448H64C28.65 448 0 419.3 0 384V128zM320 384H576V128H320V384zM178.3 175.9C175.1 168.7 167.9 164 160 164C152.1 164 144.9 168.7 141.7 175.9L77.72 319.9C73.24 329.1 77.78 341.8 87.88 346.3C97.97 350.8 109.8 346.2 114.3 336.1L123.2 315.1H196.8L205.7 336.1C210.2 346.2 222 350.8 232.1 346.3C242.2 341.8 246.8 329.1 242.3 319.9L178.3 175.9z",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    key: "translateWindowInnerWrapper",
                    staticClass: "translateWindowInnerWrapper",
                  },
                  [
                    _c("div", { staticClass: "infoContainer" }, [
                      _c("p", { staticClass: "infoTitle" }, [
                        _vm._v("Cluster: "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.selectedCluster.clusterName),
                          },
                        }),
                      ]),
                      _c("p", { staticClass: "infoTitle" }, [
                        _vm._v("Webmessage key: "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.searchKey) },
                        }),
                      ]),
                      _c("p", { staticClass: "infoTitle" }, [
                        _vm._v("Language: "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.language) },
                        }),
                      ]),
                    ]),
                    !_vm.isAllowedToEdit
                      ? _c("div", { staticClass: "notAllowedContainer" }, [
                          _c("div", { staticClass: "notAllowedInnerWrapper" }, [
                            _c(
                              "div",
                              { staticClass: "notAllowedIconWrapper" },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "notAllowedIcon",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 448 512",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M224 337.1c-17.36 0-31.44 14.08-31.44 31.44C192.6 385.9 206.6 400 224 400s31.44-14.08 31.44-31.44C255.4 351.2 241.4 337.1 224 337.1zM224 304c13.25 0 24-10.75 24-24v-128C248 138.8 237.3 128 224 128S200 138.8 200 152v128C200 293.3 210.8 304 224 304zM384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM400 416c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V96c0-8.822 7.178-16 16-16h320c8.822 0 16 7.178 16 16V416z",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c("p", { staticClass: "notAllowedText" }, [
                              _vm._v(
                                " You are not allowed to change this webmessage. Create a webmessage on the correct cluster to do so. "
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm.isAllowedToEdit
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newText,
                              expression: "newText",
                            },
                          ],
                          domProps: { value: _vm.newText },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.newText = $event.target.value
                            },
                          },
                        })
                      : _vm._e(),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isAllowedToEdit,
                            expression: "isAllowedToEdit",
                          },
                        ],
                        class: [_vm.error.state ? "error" : ""],
                        attrs: {
                          disabled:
                            _vm.done == true ||
                            _vm.error.state ||
                            _vm.isAllowedToEdit == false,
                        },
                        on: { click: _vm.submitTrans },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.error.state == false
                              ? "Translate"
                              : _vm.error.message
                          )
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }